import { render, staticRenderFns } from "./SkillGroupEdit.vue?vue&type=template&id=9489fc26"
import script from "./SkillGroupEdit.vue?vue&type=script&lang=js"
export * from "./SkillGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports